import { useMemo } from 'react';

export const CheckHistoryTypes = {
  CompletedCheck: 1,
  CompletedReferee: 2,
  CompletedRefereeIpError: 3,
  CompletedCandidate: 4,
  UpdatedEmail: 5,
  UpdatedContactNumber: 6,
  UpdatedDepartment: 7,
  UpdatedJobRole: 8,
  RequestSentCandidate: 9,
  RequestOverdueCandidate: 10,
  RequestSentReferee: 11,
  RequestOverdueReferee: 12,
  NewReferee: 13,
  NewCheck: 14,
  BackgroundCheckSubmitted: 15,
  BackgroundCheckProcessing: 16,
  BackgroundCheckCompleted: 17,
  BackgroundCheckRejected: 18,
  BackgroundCheckUpdated: 19,
  CandidateEmailFailed: 20,
  RefereeEmailFailed: 21,
  CheckCanceled: 22,
  CandidateEmailOpened: 23,
  RefereeEmailOpened: 24,
  CandidateEmailClicked: 25,
  RefereeEmailClicked: 26,
  CustomNote: 27,
  CustomInfo: 28,
  CustomSuccess: 29,
  CustomWarning: 30,
  CustomError: 31,
  CheckDeclined: 32,
  CheckAddNotes: 33,
  CheckUpdateStatus: 34,
  RefereeDeleted: 35,
  SubCheckCompleted: 36,
  CandidateSMSOpened: 37,
  RefereeSMSOpened: 38,
  RefereeReplacement: 39,
  ReminderCandidate: 40,
  ReminderReferee: 41,
  UpdatedCandidateTeam: 42,
  CheckResult: 43,
  TransferUserAssignment: 44,
  NewUserAssignment: 45,
  CheckUndoCompletion: 46,
  NewReferencePlusForm: 47,
  NewReferencePlusCommonForm: 48,
  NewReferenceForm: 49,
  UserCompletedRefereeForm: 50,
  BundleCheckAdded: 51,
  UpdatedCandidateArchived: 52,
  RefereeRequestSent: 53,
  CandidateEmailDelivered: 54,
  RefereeEmailDelivered: 55,
  CandidateRefereeBackupRequest: 56,
  SubCheckUpdateStatus: 57,
  ExternalBotMessage: 58,
  CandidateDocumentRequestSent: 59,
  CandidateDocumentUploaded: 60,
  CheckBlocked: 61,
  SubCheckCanceled: 62,
  CandidatePortalInvitationSent: 63,
  CandidateCanceledCheck: 64,
  CandidateCheckResultView: 65,
  UpdatedCandidateHiringStatus: 66,
  UserConsent: 67,
  CheckAltIdPath: 68,
  CandidateDataDeleted: 69,
  CheckResultFileDeleted: 70,
  SubCheckResultFileDeleted: 71,
  ReConsentRequested: 72,
  ReConsentSubmitted: 73,
  CheckNotification: 76,
  CandidateSMSSent: 77,
  RefereeSMSSent: 78,
  UpdatedRefereeDetails: 79,
  CandidateUpdatedRefereeDetails: 80,
  CandidateReplacedReferee: 81,
  UpdatedCandidateDetails: 82,
  CandidateNotificationListToggled: 83,
  UpdatedCandidateNotificationList: 84,
  RenewalConfigAssigned: 85,
  RenewalConfigRemoved: 86,
  RenewalInitiated: 87,
  RenewalApproved: 88,
  RenewalStopped: 89,
  RenewalConsentRequested: 90,
  RenewalConsentGiven: 91,
  RenewalConsentDeclined: 92,
  RenewalCanceled: 93,
  RenewalRestored: 94,
  AdditionalChecksRequestSent: 95,

  // Internal use only
  AdminGeneral: 1000,
  AdminFollowUpProvider: 1001,
  AdminFollowUpCandidate: 1002,
  AdminFollowUpClient: 1004,
  AdminFeedback: 1005,
  AdminSupportUserAssigned: 1006,
  AdminSupportUserUnassigned: 1007,
  AdminAppointment: 1008,
  AdminContact: 1009,
  AdminAudit: 1010,
  AdminCheckCompleted: 1011,
};

export const AdminHistoryTypes = {
  1000: { color: 'neutral', title: 'General' },
  1001: { color: 'continue', title: 'Follow up provider' },
  1002: { color: 'warning', title: 'Follow up candidate' },
  1004: { color: 'warning', title: 'Follow up client' },
  1005: { color: 'neutral', title: 'Feedback' },
  1006: { color: 'success', title: 'Support user assigned' },
  1007: { color: 'neutral', title: 'Support user unassigned' },
  1008: { color: 'continue', title: 'Appointment' },
  1009: { color: 'continue', title: 'Communication' },
  1010: { color: 'neutral', title: 'Audit' },
  1011: { color: 'neutral', title: 'Check completed' },
};

export const AdminHistoryTypesList = Object.keys(AdminHistoryTypes).map(key => ({
  value: key,
  name: AdminHistoryTypes[key].title,
}));

/** Grouped history event types for History tab filters. A type may appear in multiple groups. */
export const HistoryTypeGroups = {
  checks: {
    name: 'Checks',
    types: [
      CheckHistoryTypes.CompletedCheck,
      CheckHistoryTypes.NewCheck,
      CheckHistoryTypes.BackgroundCheckSubmitted,
      CheckHistoryTypes.BackgroundCheckProcessing,
      CheckHistoryTypes.BackgroundCheckCompleted,
      CheckHistoryTypes.BackgroundCheckRejected,
      CheckHistoryTypes.BackgroundCheckUpdated,
      CheckHistoryTypes.CheckCanceled,
      CheckHistoryTypes.CheckDeclined,
      CheckHistoryTypes.CheckAddNotes,
      CheckHistoryTypes.CheckUpdateStatus,
      CheckHistoryTypes.SubCheckCompleted,
      CheckHistoryTypes.CheckResult,
      CheckHistoryTypes.CheckUndoCompletion,
      CheckHistoryTypes.NewReferencePlusForm,
      CheckHistoryTypes.NewReferencePlusCommonForm,
      CheckHistoryTypes.NewReferenceForm,
      CheckHistoryTypes.BundleCheckAdded,
      CheckHistoryTypes.SubCheckUpdateStatus,
      CheckHistoryTypes.CheckBlocked,
      CheckHistoryTypes.SubCheckCanceled,
      CheckHistoryTypes.CheckAltIdPath,
      CheckHistoryTypes.CheckResultFileDeleted,
      CheckHistoryTypes.SubCheckResultFileDeleted,
      CheckHistoryTypes.CheckNotification,
    ],
  },
  candidates: {
    name: 'Candidates',
    types: [
      CheckHistoryTypes.CompletedCandidate,
      CheckHistoryTypes.UpdatedDepartment,
      CheckHistoryTypes.UpdatedJobRole,
      CheckHistoryTypes.RequestSentCandidate,
      CheckHistoryTypes.AdditionalChecksRequestSent,
      CheckHistoryTypes.RequestOverdueCandidate,
      CheckHistoryTypes.UpdatedCandidateTeam,
      CheckHistoryTypes.UpdatedCandidateArchived,
      CheckHistoryTypes.CandidateRefereeBackupRequest,
      CheckHistoryTypes.CandidatePortalInvitationSent,
      CheckHistoryTypes.CandidateCanceledCheck,
      CheckHistoryTypes.CandidateCheckResultView,
      CheckHistoryTypes.UpdatedCandidateHiringStatus,
      CheckHistoryTypes.CandidateDataDeleted,
      CheckHistoryTypes.BackgroundCheckSubmitted,
      CheckHistoryTypes.CandidateEmailFailed,
      CheckHistoryTypes.CandidateEmailOpened,
      CheckHistoryTypes.CandidateEmailClicked,
      CheckHistoryTypes.CandidateSMSOpened,
      CheckHistoryTypes.CandidateSMSSent,
      CheckHistoryTypes.ReminderCandidate,
      CheckHistoryTypes.CandidateEmailDelivered,
      CheckHistoryTypes.CandidateDocumentRequestSent,
      CheckHistoryTypes.CandidateDocumentUploaded,
      CheckHistoryTypes.UserConsent,
      CheckHistoryTypes.ReConsentRequested,
      CheckHistoryTypes.ReConsentSubmitted,
      CheckHistoryTypes.CandidateUpdatedRefereeDetails,
      CheckHistoryTypes.CandidateReplacedReferee,
      CheckHistoryTypes.UpdatedCandidateDetails,
      CheckHistoryTypes.CandidateNotificationListToggled,
      CheckHistoryTypes.UpdatedCandidateNotificationList,
      CheckHistoryTypes.RenewalConfigAssigned,
      CheckHistoryTypes.RenewalConfigRemoved,
      CheckHistoryTypes.RenewalInitiated,
      CheckHistoryTypes.RenewalApproved,
      CheckHistoryTypes.RenewalStopped,
      CheckHistoryTypes.RenewalCanceled,
      CheckHistoryTypes.RenewalRestored,
      CheckHistoryTypes.RenewalConsentRequested,
      CheckHistoryTypes.RenewalConsentGiven,
      CheckHistoryTypes.RenewalConsentDeclined,
    ],
  },
  referees: {
    name: 'Referees',
    types: [
      CheckHistoryTypes.CompletedReferee,
      CheckHistoryTypes.CompletedRefereeIpError,
      CheckHistoryTypes.UpdatedEmail,
      CheckHistoryTypes.UpdatedContactNumber,
      CheckHistoryTypes.RequestSentReferee,
      CheckHistoryTypes.RequestOverdueReferee,
      CheckHistoryTypes.NewReferee,
      CheckHistoryTypes.RefereeDeleted,
      CheckHistoryTypes.RefereeReplacement,
      CheckHistoryTypes.UserCompletedRefereeForm,
      CheckHistoryTypes.RefereeRequestSent,
      CheckHistoryTypes.UpdatedRefereeDetails,
      CheckHistoryTypes.CandidateUpdatedRefereeDetails,
      CheckHistoryTypes.CandidateReplacedReferee,
      CheckHistoryTypes.CandidateRefereeBackupRequest,
      CheckHistoryTypes.RefereeEmailFailed,
      CheckHistoryTypes.RefereeEmailOpened,
      CheckHistoryTypes.RefereeEmailClicked,
      CheckHistoryTypes.RefereeSMSOpened,
      CheckHistoryTypes.ReminderReferee,
      CheckHistoryTypes.RefereeEmailDelivered,
      CheckHistoryTypes.RefereeSMSSent,
    ],
  },
  communications: {
    name: 'Emails & messages',
    types: [
      CheckHistoryTypes.CandidateEmailFailed,
      CheckHistoryTypes.RefereeEmailFailed,
      CheckHistoryTypes.CandidateEmailOpened,
      CheckHistoryTypes.RefereeEmailOpened,
      CheckHistoryTypes.CandidateEmailClicked,
      CheckHistoryTypes.RefereeEmailClicked,
      CheckHistoryTypes.CandidateSMSOpened,
      CheckHistoryTypes.RefereeSMSOpened,
      CheckHistoryTypes.ReminderCandidate,
      CheckHistoryTypes.ReminderReferee,
      CheckHistoryTypes.CandidateEmailDelivered,
      CheckHistoryTypes.RefereeEmailDelivered,
      CheckHistoryTypes.ExternalBotMessage,
      CheckHistoryTypes.RequestSentCandidate,
      CheckHistoryTypes.AdditionalChecksRequestSent,
      CheckHistoryTypes.RequestOverdueCandidate,
      CheckHistoryTypes.RequestSentReferee,
      CheckHistoryTypes.RequestOverdueReferee,
      CheckHistoryTypes.RefereeRequestSent,
      CheckHistoryTypes.CandidatePortalInvitationSent,
      CheckHistoryTypes.CandidateRefereeBackupRequest,
      CheckHistoryTypes.CandidateDocumentRequestSent,
      CheckHistoryTypes.ReConsentRequested,
      CheckHistoryTypes.CandidateSMSSent,
      CheckHistoryTypes.RefereeSMSSent,
      CheckHistoryTypes.RenewalConsentRequested,
    ],
  },
  notes: {
    name: 'Notes',
    types: [
      CheckHistoryTypes.CustomNote,
      CheckHistoryTypes.CustomInfo,
      CheckHistoryTypes.CustomSuccess,
      CheckHistoryTypes.CustomWarning,
      CheckHistoryTypes.CustomError,
      CheckHistoryTypes.CheckAddNotes,
      CheckHistoryTypes.ExternalBotMessage,
    ],
  },
  documents: {
    name: 'Documents & consent',
    types: [
      CheckHistoryTypes.CandidateDocumentRequestSent,
      CheckHistoryTypes.CandidateDocumentUploaded,
      CheckHistoryTypes.UserConsent,
      CheckHistoryTypes.ReConsentRequested,
      CheckHistoryTypes.ReConsentSubmitted,
    ],
  },
  assignments: {
    name: 'Assignments',
    types: [CheckHistoryTypes.TransferUserAssignment, CheckHistoryTypes.NewUserAssignment],
  },
  renewals: {
    name: 'Renewals',
    types: [
      CheckHistoryTypes.RenewalConfigAssigned,
      CheckHistoryTypes.RenewalConfigRemoved,
      CheckHistoryTypes.RenewalInitiated,
      CheckHistoryTypes.RenewalApproved,
      CheckHistoryTypes.RenewalStopped,
      CheckHistoryTypes.RenewalCanceled,
      CheckHistoryTypes.RenewalRestored,
      CheckHistoryTypes.RenewalConsentRequested,
      CheckHistoryTypes.RenewalConsentGiven,
      CheckHistoryTypes.RenewalConsentDeclined,
    ],
  },
};

export const HistoryTypeGroupOptions = Object.entries(HistoryTypeGroups).map(([value, group]) => ({
  value,
  name: group.name,
}));

export const historyTypesForGroups = groupKeys => {
  if (!groupKeys?.length) return null;
  const types = new Set();
  for (const key of groupKeys) {
    const group = HistoryTypeGroups[key];
    if (!group) continue;
    for (const type of group.types) types.add(type);
  }
  return types;
};

export const CommunicationHistoryTypes = historyTypesForGroups(['communications']);
